import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { SchoolPage } from "./pages/SchoolPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { CabinetPage } from "./pages/CabinetPage";
import { BoardPage } from "./pages/BoardPage";
import { BoardSettingsPage } from "./pages/BoardSettingsPage";
import { GuestBoardPage } from "./pages/GuestBoardPage";
import { AcceptInvitePage } from "./pages/AcceptInvitePage";
import { FolderSettingsPage } from "./pages/FolderSettingsPage";
import { TrashPage } from "./pages/TrashPage";
import { LegacyRedirect } from "./pages/LegacyRedirect";
import { AdminBillingPage, AdminBillingRedirect } from "./pages/AdminBillingPage";
import { AppUpdateBanner } from "./components/AppUpdateBanner";

export function App() {
  return (
    <BrowserRouter>
      {/* Полоска «вышло обновление»: вкладка сама узнаёт о новой версии. */}
      <AppUpdateBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/school" element={<SchoolPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<Navigate to="/login" replace />} />
        <Route path="/reset-password" element={<Navigate to="/login" replace />} />
        <Route path="/cabinet" element={<CabinetPage />} />
        <Route path="/board/:id" element={<BoardPage />} />
        <Route path="/board/:id/settings" element={<BoardSettingsPage />} />
        <Route path="/folder/:id/settings" element={<FolderSettingsPage />} />
        <Route path="/invite/accept" element={<AcceptInvitePage />} />
        <Route path="/guest/board/:id" element={<GuestBoardPage />} />
        <Route path="/trash" element={<TrashPage />} />
        <Route path="/admin/school" element={<AdminBillingPage key="school" scope="school" />} />
        <Route path="/admin/external" element={<AdminBillingPage key="external" scope="external" />} />
        <Route path="/admin/billing" element={<AdminBillingRedirect />} />
        <Route path="/cabinet.html" element={<LegacyRedirect />} />
        <Route path="/login.html" element={<LegacyRedirect />} />
        <Route path="/register.html" element={<LegacyRedirect />} />
        <Route path="/trash.html" element={<LegacyRedirect />} />
        <Route path="/forgot-password.html" element={<LegacyRedirect />} />
        <Route path="/reset-password.html" element={<LegacyRedirect />} />
        <Route path="/board-settings.html" element={<LegacyRedirect />} />
        <Route path="/user-board.html" element={<LegacyRedirect />} />
        <Route path="/board.html" element={<LegacyRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
